import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, isRef as _isRef, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"background-color":"#f5f5f5","overflow":"hidden","margin-top":"0.7rem"} }
const _hoisted_2 = { class: "authentication comBox" }
const _hoisted_3 = { class: "authen_head" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "authen_head_right" }
const _hoisted_6 = { style: {"display":"inline-block","margin-right":"0.16rem"} }
const _hoisted_7 = { style: {"display":"inline-block","margin-right":"0.16rem"} }
const _hoisted_8 = { class: "authen_content" }
const _hoisted_9 = { style: {"width":"100%"} }
const _hoisted_10 = { style: {"color":"#000"} }
const _hoisted_11 = {
  key: 0,
  class: "modifyCoverUpload"
}
const _hoisted_12 = ["src"]

import { reactive, ref, FormRules } from "vue";
import basicsPage from "./basicsPage.vue";
import enterprisePage from "./enterprise/enterprisePage";
import sccountPage from "./sccountPage";
import { Axios } from "../../assets/js/ls_com_axios.js";
import { useRouter } from "vue-router";
import { serverBaseUrl } from "../../assets/js/ls_tgServerUrls.js";
import { ElMessage, ElNotification, Message } from "element-plus";

export default /*@__PURE__*/_defineComponent({
  __name: 'authenTication',
  setup(__props) {

const imageUrl = ref("");
const modifyCover = ref(false);
const upload_showImage = ref(serverBaseUrl + "/file/upload");
const router = new useRouter();
document.title = "标识山西-个人中心";
let activeName = ref("1");
if (router.currentRoute.value.query.num) {
  activeName.value = router.currentRoute.value.query.num;
}
let num_type = ref("");
if (router.currentRoute.value.query.params) {
  num_type.value = router.currentRoute.value.query.params;
}
const handleClick = (tab, event) => {
  // console.log(tab, event);
};
const rules = reactive<FormRules>({
  realName: [{ required: true, message: "不能为空！", trigger: "change" }],
  idCard: [{ required: true, message: "不能为空！", trigger: "change" }],
  frontSrc: [{ required: true, message: "不能为空！", trigger: "change" }],
  reverseSrc: [{ required: true, message: "不能为空！", trigger: "change" }],
});
const loginInfo: any = ref({});
const onSuccessImages = (file) => {
  console.log("file", file);
  imageUrl.value = file.data.url;
};
const submitSaverBg = () => {
  // return console.log(imageUrl.value);

  Axios(
    "get",
    `/member/setting-avater`,
    { avater: imageUrl.value },
    false,
    function (res) {
      console.log("=================", res);
      modifyCover.value = false;
      ElMessage.success("上传成功");
      getInfo();
    }
  );
};
const getInfo = () => {
  Axios("get", `/member/login-info`, {}, false, (res) => {
    let data = res.data.data;
    data.realStatusName =
      data.realStatus == 0
        ? "待认证"
        : data.realStatus == 1
          ? "审核中"
          : data.realStatus == 2
            ? "认证成功"
            : "认证失败";
    data.userrealStatusColor == 0
      ? "#ff8c"
      : data.realStatus == 1
        ? "#4169"
        : data.realStatus == 2
          ? "#00cc33"
          : "red";

    loginInfo.value = data;
  });
};
getInfo();

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "authen_head_img",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (imageUrl.value = loginInfo.value.avatar ? loginInfo.value.avatar : '', modifyCover.value = true))
        }, [
          _createElementVNode("img", {
            src: loginInfo.value.avatar,
            alt: ""
          }, null, 8, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", null, [
            _cache[4] || (_cache[4] = _createElementVNode("span", { class: "authen_head_right_left" }, "用户名", -1)),
            _createElementVNode("span", null, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(loginInfo.value.nickName), 1)
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[5] || (_cache[5] = _createElementVNode("span", { class: "authen_head_right_left" }, "实名认证", -1)),
            _createElementVNode("span", {
              style: _normalizeStyle({ color: loginInfo.value.userrealStatusColor }),
              class: "authen_head_right_renzhenType"
            }, _toDisplayString(loginInfo.value.realStatusName), 5)
          ]),
          _createElementVNode("div", null, [
            _cache[6] || (_cache[6] = _createElementVNode("span", { class: "authen_head_right_left" }, "账号ID", -1)),
            _createElementVNode("span", null, _toDisplayString(loginInfo.value.code), 1)
          ]),
          _createElementVNode("div", null, [
            _cache[7] || (_cache[7] = _createElementVNode("span", { class: "authen_head_right_left" }, "手机号码", -1)),
            _createElementVNode("span", null, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(loginInfo.value.phonenumber
                  ? loginInfo.value.phonenumber.substring(0, 3) +
                  "******" +
                  loginInfo.value.phonenumber.substring(9, 11)
                  : ""), 1),
              _createElementVNode("span", {
                style: {"color":"#165dff"},
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_isRef(activeName) //@ts-ignore
 ? activeName.value = '2' : activeName = '2'))
              }, "修改")
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[8] || (_cache[8] = _createElementVNode("span", { class: "authen_head_right_left" }, "注册时间", -1)),
            _createElementVNode("span", null, _toDisplayString(loginInfo.value.createTime), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_el_tabs, {
          modelValue: _unref(activeName),
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(activeName) ? (activeName).value = $event : activeName = $event)),
          class: "demo-tabs",
          onTabClick: handleClick
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tab_pane, {
              label: "基本信息",
              name: "1"
            }, {
              default: _withCtx(() => [
                _createVNode(basicsPage)
              ]),
              _: 1
            }),
            _createVNode(_component_el_tab_pane, {
              label: "账号安全",
              name: "2"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(sccountPage))
              ]),
              _: 1
            }),
            _createVNode(_component_el_tab_pane, {
              label: "账号认证",
              name: "3"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(enterprisePage), {
                  title: _unref(router).currentRoute.value.query.type || 0
                }, null, 8, ["title"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      title: "更换头像",
      modelValue: modifyCover.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((modifyCover).value = $event)),
      "align-center": "",
      width: "400px",
      "close-on-click-modal": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_el_upload, {
            class: "avatar-uploader",
            accept: " image/*",
            style: {"border-radius":"50%"},
            action: upload_showImage.value,
            "show-file-list": false,
            "on-success": onSuccessImages
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_10, [
                (!imageUrl.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, "上传头像"))
                  : _createCommentVNode("", true),
                _createElementVNode("img", {
                  src: imageUrl.value,
                  class: "avatar",
                  style: {"object-fit":"cover","width":"178px","height":"178px","display":"block","border-radius":"50%"}
                }, null, 8, _hoisted_12)
              ])
            ]),
            _: 1
          }, 8, ["action"])
        ]),
        _cache[9] || (_cache[9] = _createElementVNode("div", { style: {"margin":"0.12rem 0 0.2rem"} }, [
          _createElementVNode("div", { style: {"color":"#86909c","text-align":"center","font-size":"0.12rem","margin-bottom":"0.02rem"} }, " 请上传格式为 JPG、JPEG、PNG 的文件。 "),
          _createElementVNode("div", { style: {"color":"#86909c","text-align":"center","font-size":"0.12rem"} }, " 文件大小不超过 5M。 ")
        ], -1)),
        _createElementVNode("div", {
          class: "modifyCoverBnt",
          onClick: submitSaverBg
        }, "保存")
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})